import * as React from "react";
import PropTypes from 'prop-types';


const SkiplyLogoPurple = ({bgColor = '#7950FF'}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="137"
      height="51"
      viewBox="0 0 137 51"
      fill="none"
    >
      <path
        d="M63.0438 12.4387H54.3965V38.761H63.0438V12.4387Z"
        fill={bgColor}
      />
      <path
        d="M58.7262 0C55.7651 0 53.3467 2.0257 53.3467 4.50157C53.3467 6.98927 55.7651 9.01497 58.7262 9.01497C61.6872 9.01497 64.1057 6.98927 64.1057 4.50157C64.1057 2.0257 61.6872 0 58.7262 0Z"
        fill={bgColor}
      />
      <path
        d="M51.1401 12.4387H42.4928C42.3041 17.1298 39.1896 21.7025 35.4617 22.2474V3.11572H26.8145V38.761H35.4617V29.0116C39.4846 29.284 42.3041 34.0699 42.4928 38.761H51.1401C51.0575 35.5388 49.9958 31.9731 48.3206 29.3433C47.2707 27.6848 45.4185 26.7016 43.4602 26.7016H40.794L40.7822 24.8891H43.6018C45.4303 24.8891 47.1763 24.048 48.238 22.5672C50.5975 19.3095 51.0929 15.0093 51.1401 12.4387Z"
        fill={bgColor}
      />
      <path
        d="M137 12.4385H128.364V26.7132C128.364 28.7626 127.786 31.6175 124.495 31.6175C122.076 31.6175 120.106 30.2434 120.106 27.2344V12.4385H111.459V28.727C111.459 35.6689 115.352 39.4123 121.227 39.4123C128.01 39.4123 128.282 33.276 128.282 33.276L129.568 33.2642L129.591 34.9345C129.591 38.3699 127.727 42.291 120.944 42.291C116.437 42.291 113.641 40.9523 113.641 40.9523V48.3325C113.641 48.3325 116.85 50.5478 121.994 50.5478C133.649 50.5478 136.988 42.0541 136.988 34.3303V12.4385H137Z"
        fill={bgColor}
      />
      <path
        d="M9.23715 19.8894C9.23715 18.9181 9.94498 18.148 11.3134 18.148C12.7881 18.148 13.6965 19.1076 13.6965 20.8608H23.146C23.146 13.5162 16.457 11.7866 11.4904 11.7866C4.90761 11.7866 0 14.7837 0 19.4985C0 29.8403 14.2273 26.393 14.2273 31.0367C14.2273 32.3161 13.1302 32.9321 11.7617 32.9321C9.34332 32.9321 9.11918 31.1433 9.11918 30.4089H0.0117978C0.0117978 37.1612 5.94575 39.412 11.7971 39.412C19.4535 39.412 23.665 36.64 23.665 31.2026C23.6532 22.0455 9.23715 24.9952 9.23715 19.8894Z"
        fill={bgColor}
      />
      <path
        d="M107.295 3.11572H98.6475V38.761H107.295V3.11572Z"
        fill={bgColor}
      />
      <path
        d="M85.0696 11.7866C78.4278 11.7866 77.1419 17.9467 77.1419 17.9467H75.8914V12.4382H67.2441V48.0835H75.8678H75.8914V33.2638H77.2009C77.2009 33.2638 77.4722 39.4239 84.6803 39.4239C90.7794 39.4239 95.5454 34.1049 95.5454 25.7296C95.5454 18.7285 92.8085 11.7866 85.0696 11.7866ZM81.6012 31.4632C78.8643 31.4632 76.6347 28.8215 76.6347 25.5875C76.6347 22.3416 78.8643 19.7117 81.6012 19.7117C84.3382 19.7117 86.5678 22.3535 86.5678 25.5875C86.5678 28.8333 84.3382 31.4632 81.6012 31.4632Z"
        fill={bgColor}
      />
    </svg>
  );
};

SkiplyLogoPurple.propTypes = {
  bgColor: PropTypes.string,
};


export default SkiplyLogoPurple;
